var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-check" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "share-box",
        class: { show: !_vm.loading && !_vm.showNoFile }
      },
      [
        _c("img", {
          attrs: { src: require("../../assets/images/logo.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "share-message" }, [
          _vm.lang === "en"
            ? _c("span", { staticClass: "share-text" }, [
                _vm._v(_vm._s(_vm.$t("share.shared") + _vm.userName))
              ])
            : _vm.lang === "ru_RU"
            ? _c("span", { staticClass: "share-text" }, [
                _vm._v(_vm._s(_vm.$t("share.shared") + _vm.userName))
              ])
            : _c("span", { staticClass: "share-text" }, [
                _vm._v(_vm._s(_vm.userName) + _vm._s(_vm.$t("share.shared")))
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "share-code" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.code,
                expression: "code"
              }
            ],
            staticClass: "input-pwd",
            class: { error: _vm.inputRequire },
            attrs: { type: "text", placeholder: _vm.$t("share.enterPassword") },
            domProps: { value: _vm.code },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.code = $event.target.value
                },
                _vm.inputOnchange
              ],
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.checkCode($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.verifyMsg
            ? _c("div", { staticClass: "verify-msg" }, [
                _vm._v(_vm._s(_vm.codeMsg))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showCheckBtn
            ? _c("i", {
                staticClass: "icon-login-btn",
                on: { click: _vm.checkCode }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-loading", class: { show: _vm.checking } },
            [
              _c(
                "div",
                { staticClass: "container" },
                [_c("loading", { attrs: { loading: true } })],
                1
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "request-box", class: { show: _vm.loading } }, [
      _vm._m(1)
    ]),
    _vm._v(" "),
    _vm.showNoFile
      ? _c("div", { staticClass: "check-result" }, [
          _c("div", { staticClass: "no-file" }, [
            _c("div", { staticClass: "no-file-main" }, [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/no_file.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.fileMessage))])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "share-header" }, [
      _c("i", { staticClass: "icon-czur-logo" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ball-pulse" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7127cd69", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7127cd69","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Et/ShareCheck.vue
// module id = null
// module chunks = 